import { httpRequest } from '@/services/httpClient'

export type RoleItem = {
  roleId: number
  tenantId: number | null
  name: string
  code: string | null
  description: string | null
  isSystemRole: boolean | null
  isActive?: boolean
  isDeleted?: boolean
  createdAt?: string
  lastUpdated?: string
}

export type RoleListResponse = {
  items: RoleItem[]
  totalCount: number
  page: number
  pageSize: number
}

export type RoleListParams = {
  tenantId?: number
  isActive?: boolean | null
  includeDeleted?: boolean
  search?: string
  page?: number
  pageSize?: number
  sortBy?: string
  sortDir?: 'asc' | 'desc'
}

export type CreateRolePayload = {
  tenantId?: number
  code: string
  name: string
  description?: string | null
  isSystemRole?: boolean
}

export type UpdateRolePayload = CreateRolePayload & {
  id: number
}

export type RoleMenusResponse = {
  menuIds: number[]
}

export type UpdateRoleMenusPayload = {
  tenantId: number | null
  menuIds: number[]
}

export const rolesApi = {
  list: (params: RoleListParams) =>
    httpRequest<RoleListResponse>('/v1/roles', {
      method: 'GET',
      query: {
        tenantId: params.tenantId ?? undefined,
        isActive: params.isActive ?? undefined,
        includeDeleted: params.includeDeleted ?? undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
      },
    }),

  getById: (id: number) => httpRequest<RoleItem>(`/v1/roles/${id}`, { method: 'GET' }),

  getRoleMenus: (roleId: number, tenantId: number | null) =>
    httpRequest<RoleMenusResponse>(`/v1/roles/${roleId}/menus`, {
      method: 'GET',
      query: tenantId != null ? { tenantId } : {},
    }),

  // PUT goes via /api/identity/... so gateway's identity-route forwards to identity (avoids /api/v1 route 404)
  updateRoleMenus: (roleId: number, payload: UpdateRoleMenusPayload) =>
    httpRequest<void>(`/identity/roles/${roleId}/menus`, {
      method: 'PUT',
      body: {
        tenantId: payload.tenantId,
        menuIds: payload.menuIds,
      },
    }),
}
